{
    "name": "dottnet",
    "version": "1.0",
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "serve:ssr:dottnet_client": "node --inspect dist/dottnet_client/server/server.mjs",
        "build_and_serve:ssr:dottnet_client": "ng build --configuration ssr-development & node dist/dottnet_client/server/server.mjs",
        "start:prod": "npm run build:prod && npm run server",
        "source-map-explorer": "source-map-explorer dist/dottnet_client/browser/*.js",
        "format:write": "prettier projects/**/*.{ts,json,scss,html} --write",
        "format:test": "prettier projects/**/*.{ts,json,scss} --list-different",
        "ng-lint": "ng lint dottnet",
        "ng-lint-fix": "ng lint dottnet --fix",
        "build:ssr-prod": "ng build --configuration production",
        "build:ssr-staging": "ng build --configuration staging",
        "build:ssr-dev": "ng build --configuration ssr-development",
        "cypress:open": "cypress open",
        "cypress:run": "cypress run"
    },
    "husky": {
        "hooks": {
            "pre-commit": "pretty-quick --staged",
            "commit-msg": "commitlint -E HUSKY_GIT_PARAMS"
        }
    },
    "commitlint": {
        "extends": [
            "@commitlint/config-conventional"
        ]
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.0.6",
        "@angular/cdk": "^19.0.5",
        "@angular/common": "^19.0.6",
        "@angular/compiler": "^19.0.6",
        "@angular/core": "^19.0.6",
        "@angular/forms": "^19.0.6",
        "@angular/material": "^19.0.5",
        "@angular/platform-browser": "^19.0.6",
        "@angular/platform-browser-dynamic": "^19.0.6",
        "@angular/platform-server": "^19.0.6",
        "@angular/router": "^19.0.6",
        "@angular/ssr": "^19.0.7",
        "@fortawesome/angular-fontawesome": "^1.0.0",
        "@fortawesome/fontawesome-svg-core": "^6.4.0",
        "@fortawesome/free-brands-svg-icons": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@ngrx/effects": "^19.0.0",
        "@ngrx/entity": "^19.0.0",
        "@ngrx/operators": "^19.0.0",
        "@ngrx/router-store": "^19.0.0",
        "@ngrx/store": "^19.0.0",
        "@ngrx/store-devtools": "^19.0.0",
        "@ngx-translate/core": "^16.0.4",
        "@ngx-translate/http-loader": "^16.0.1",
        "@stripe/stripe-js": "^1.54.0",
        "@wwei/dfp": "^15.0.0",
        "@zoomus/websdk": "^2.11.0",
        "angular-material": "^1.2.5",
        "async-mutex": "^0.4.0",
        "dexie": "^3.2.3",
        "domino-ext": "^2.1.4",
        "eslint-plugin-import": "^2.30.0",
        "express": "^4.15.2",
        "form-data": "^4.0.0",
        "hammerjs": "^2.0.8",
        "isbot": "^5.1.21",
        "ng2-pdf-viewer": "^10.3.0",
        "ngx-skeleton-loader": "^7.0.0",
        "node-html-parser": "^6.1.5",
        "npm-check": "^6.0.1",
        "rxjs": "^7.8.0",
        "tslib": "^2.5.0",
        "video.js": "^8.12.0",
        "videojs-contrib-ads": "^7.5.2",
        "videojs-ima": "^2.3.0",
        "web-animations-js": "^2.3.2",
        "xhr2": "^0.2.1",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.0.7",
        "@angular-eslint/builder": "18.3.0",
        "@angular-eslint/eslint-plugin": "18.3.0",
        "@angular-eslint/eslint-plugin-template": "18.3.0",
        "@angular-eslint/schematics": "^18.3.0",
        "@angular-eslint/template-parser": "18.3.0",
        "@angular/cli": "^19.0.7",
        "@angular/compiler-cli": "^19.0.6",
        "@angular/language-service": "^19.0.6",
        "@commitlint/cli": "^17.5.1",
        "@commitlint/config-conventional": "^17.4.4",
        "@cypress/schematic": "^2.5.1",
        "@types/express": "^5.0.0",
        "@types/gtag.js": "^0.0.12",
        "@types/jasmine": "^4.3.1",
        "@types/node": "^22.10.5",
        "@types/uuid": "^9.0.1",
        "@typescript-eslint/eslint-plugin": "8.4.0",
        "@typescript-eslint/parser": "8.4.0",
        "all-contributors-cli": "^6.24.0",
        "assert": "^2.0.0",
        "browser-sync": "^3.0.0",
        "codelyzer": "^6.0.2",
        "cypress": "latest",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^8.8.0",
        "eslint-plugin-ngrx": "^2.1.4",
        "eslint-plugin-only-warn": "^1.1.0",
        "eslint-plugin-rxjs-angular": "^2.0.1",
        "express": "^4.16.4",
        "husky": "^8.0.3",
        "jasmine-core": "^4.6.0",
        "jasmine-spec-reporter": "^7.0.0",
        "karma": "^6.4.1",
        "karma-chrome-launcher": "^3.1.1",
        "karma-coverage": "^2.2.0",
        "karma-jasmine": "^5.1.0",
        "karma-jasmine-html-reporter": "^2.0.0",
        "karma-spec-reporter": "^0.0.36",
        "npm-run-all": "^4.1.5",
        "pretty-quick": "^3.1.3",
        "rimraf": "^5.0.0",
        "source-map-explorer": "^2.5.3",
        "standard-version": "^9.5.0",
        "ts-node": "^10.9.1",
        "tslint": "~6.1.3",
        "typescript": "^5.6.3",
        "webpack-bundle-analyzer": "^4.8.0"
    }
}
